import React, { Fragment } from "react"
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import FormInput from '../../../components/FormInput'
import { Row, Col, Form } from 'react-bootstrap'
import SusceptibilityTests from './SusceptibilityTests'
import { connect } from 'react-redux'
import { updatePathogen, updatePrimaryInfectionSite, deleteSusceptibilityTestFromServer } from '../reducers/infectionCourseFormReducer'

const PathogenSpecificQuestions = (props) => {
  const {
    site,
    pathogen,
    handleSelect,
    patchPathogen,
    checkboxPatchPathogen,
    addNewSusceptibilityTest,
    handlePathogenBlur,
    handleSusceptibilityTestBlur,
    chartForReview,
    savingChartPhase,
    chartDateErrorMessage
  } = props


  const handleSusceptibilityTestDone = (e) => {
    let value
    if (e.target.value === 'Yes') {
      value = true
    } else {
      value = false
    }

    if (value === false) {
      //if no is selected, check to see if any susceptibility tests were added and remove them
      props.pathogen.susceptibility_tests.forEach(susceptibilityTest => {
        return props.deleteSusceptibilityTestFromServer(susceptibilityTest, props)
      })

    }
    const updatedPathogen = {...props.pathogen, susceptibility_test_done: value }
    const pathogenInfo = {primaryInfectionSite: props.site, pathogen: updatedPathogen, key: 'susceptibility_test_done', value: value}
    props.submitChartPathogenInfo(props, pathogenInfo)

    return patchPathogen(value, props.site, updatedPathogen, 'susceptibility_test_done')
  }


  const getRequired = (options) => {
    if (options.length !== 0) {
      let required = true
      options.forEach(option => {
        if (props.pathogen[option.fieldName]) {
          required = false
        }
      })
      return required
    } else {
      return null
    }
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let name = chartDateErrorMessage.split('[')[1].split(']')[0]
        if (key === name || name.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const samePathogenPriorToCurrentHospitalizationOptions = [
    {value: 'No',
    fieldName: 'No'},
    {value: 'Unknown',
    fieldName: 'Unknown'},
    {value: 'Yes, as Infection',
    fieldName: 'Yes, as Infection'},
    {value: 'Yes, as Colonization',
    fieldName: 'Yes, as Colonization'},
  ]

  const sourceOfCultureSampleOptions = [
    {displayName: 'Blood',
    fieldName: 'source_of_culture_sample_blood'},
    {displayName: 'Respiratory',
    fieldName: 'source_of_culture_sample_respiratory'},
    {displayName: 'Urine',
    fieldName: 'source_of_culture_sample_urine'},
    {displayName: 'GI tract (Fecal)',
    fieldName: 'source_of_culture_sample_gi_tract_fecal'},
    {displayName: 'Intra-Abdominal',
    fieldName: 'source_of_culture_sample_intra_abdominal'},
    {displayName: 'Bone/Joint',
    fieldName: 'source_of_culture_sample_bone_joint'},
    {displayName: 'Skin and Skin Structure',
    fieldName: 'source_of_culture_sample_skin'},
    {displayName: 'Other',
    fieldName: 'source_of_culture_sample_other',
    textFields: [
      {displayName: 'Please Specify',
      fieldName: 'source_of_culture_sample_other_text'}
    ]},
  ]

  const patientLocationWhenIndexCultureTakenOptions = [
    {value: 'Outpatient Clinic',
    fieldName: 'Outpatient Clinic'},
    {value: 'Emergency Room',
    fieldName: 'Emergency Room'},
    {value: 'General Ward',
    fieldName: 'General Ward'},
    {value: 'ICU',
    fieldName: 'ICU'},
    {value: 'Operating theatre (intra-operative sample)',
    fieldName: 'Operating theatre (intra-operative sample)'},
    {value: 'Other',
    fieldName: 'Other',
    textFields: [
      {displayName: 'Please Specify',
      fieldName: 'patient_location_when_index_culture_taken_other_text'}
    ]},
  ]

  const otherPathogensInSameCultureOptions = [
    {displayName: 'Gram Positive non-anaerobe',
    fieldName: 'gram_positive_non_anaerobe',
    textFields: [
      {displayName: 'Please Specify',
      fieldName: 'gram_positive_non_anaerobe_description'}
    ]},
    {displayName: 'Anaerobes',
    fieldName: 'anaerobes',
    textFields: [
      {displayName: 'Please Specify',
      fieldName: 'anaerobes_description'}
    ]},
    {displayName: 'Fungi',
    fieldName: 'fungi',
    textFields: [
      {displayName: 'Please Specify',
      fieldName: 'fungi_description'}
    ]}
  ]

  const pathogenInSameCultureQuestion = () => {
    let optionsAreRequired = !otherPathogensInSameCultureOptions.find(option => props.pathogen[option.fieldName] === true)
    return otherPathogensInSameCultureOptions.map(option => {
      const optionIsSelected = props.pathogen[option.fieldName] === true

      const handlePathogenInSameCultureSelection = () => {
        const pathogenToPatch = { ...props.pathogen }
        option.textFields.forEach(textField => {
          if (textField?.fieldName) {
            pathogenToPatch[textField.fieldName] = ''
          }
        })
        checkboxPatchPathogen(!optionIsSelected, props.site, pathogenToPatch, option.fieldName)
      }

      return (
        <div className="indented-row" key={pathogen.id + option.fieldName}>
          <Row style={{ paddingTop: "0" }} key={option.fieldName}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Form.Check
                id={option.fieldName}
                name={option.fieldName}
                label={option.displayName}
                value={optionIsSelected}
                checked={optionIsSelected}
                onChange={handlePathogenInSameCultureSelection}
                disabled={chartForReview || savingChartPhase ? true : false}
                required={optionsAreRequired}
              />

              {optionIsSelected && option.textFields && option.textFields.length > 0 ?
                <Fragment>
                  {option.textFields.map(textField => {
                    return (
                      <Row key={textField.fieldName} style={{marginBottom: '10px'}}>
                        <Col xs={1} sm={1} md={1} lg={1}>
                        </Col>

                        <Col xs={10} sm={11} md={11} lg={11}>
                          <Form.Label>
                            {textField.displayName}
                          </Form.Label>
                          <Form.Control
                            key={`${textField.fieldName} ${option.textFields.indexOf(textField)}`}
                            className='text-option-checkbox-form'
                            name={textField.fieldName}
                            value={props.pathogen[textField.fieldName]}
                            onChange={(e, site, pathogen) => patchPathogen(e, props.site, props.pathogen)}
                            onBlur={() => handlePathogenBlur(site, pathogen)}
                            placeholder={textField.displayName}
                            disabled={chartForReview || savingChartPhase ? true : false}
                            required={true}
                          />
                        </Col>
                      </Row>
                    )
                  })
                  }
                </Fragment>
                :
                null
              }
            </Col>
          </Row>
        </div>
      )
    })
  }

  const handlePatientHadSamePathogenSelect = (e, site, pathogen) => {
    const pathogenToUpdate = { ...props.pathogen }
    if (!e.target.value.includes('Yes')) {
      pathogenToUpdate.initial_positive_culture_date = null
      sourceOfCultureSampleOptions.forEach(option => {
        if (option.fieldName) {
          pathogenToUpdate[option.fieldName] = false
          if (option.textFields) {
            option.textFields.forEach(field => {
              if (field.fieldName) {
                pathogenToUpdate[field.fieldName] = ''
              }
            })
          }
        }
      })
    }
    patchPathogen(e, props.site, pathogenToUpdate)
  }

  const pathogenRadioIdName = `${props.pathogen.primary_infection_site}-${props.pathogen.name.split(' ').join('')}-${props.pathogen.id}`


  return (
    <div className="">
      <FormInput
        label={'Date the index culture samples were taken to identify the indicated or index GNBI at the corresponding infection site:'}
        name={'date_index_culture_sample_taken'}
        value={props.pathogen.date_index_culture_sample_taken}
        type={'date'}
        showTimeSelect={true}
        infoText={'Index culture is the culture sample identified the indicated GN pathogen and supported the cefiderocol use. If multiple positive cultures of the same isolate obtained at the index time period (such as on the same day) only answer questions using the most recent one to the initiation of cefiderocol'}
        onChange={(date, site, pathogen, name) => patchPathogen(date, props.site, props.pathogen, 'date_index_culture_sample_taken')}
        disabled={chartForReview}
        required={true}
        errorText={getHelperText('date_index_culture_sample_taken')}
      />

      <FormInput
        label={'Time the index culture samples were taken to identify the indicated or index GNBI at the corresponding infection site:'}
        name={'time_index_culture_sample_taken'}
        value={props.pathogen.time_index_culture_sample_taken}
        type={'time'}
        infoText={'Index culture is the culture sample identified the indicated GN pathogen and supported the cefiderocol use. If multiple positive cultures of the same isolate obtained at the index time period (such as on the same day) only answer questions using the one that was taken in closest proximity to the initiation of cefiderocol]'}
        showTimeSelect={true}
        onChange={(e, site, pathogen, name) => {
          patchPathogen(e, props.site, props.pathogen, 'time_index_culture_sample_taken')
        }}
        disabled={chartForReview}
        required={false}
        errorText={getHelperText('time_index_culture_sample_taken')}
      />

      <SelectWithOptionalTextField
        label='Where was the patient located when the index culture was obtained?'
        options={patientLocationWhenIndexCultureTakenOptions}
        selectFieldName='patient_location_when_index_culture_taken'
        selected={props.pathogen.patient_location_when_index_culture_taken}
        handleSelect={handleSelect}
        handleChange={(e, site, pathogen) => {
          const updatedPathogen = {
            ...props.pathogen,
            patient_location_when_index_culture_taken_other_text: '',
          }
          patchPathogen(e, props.site, updatedPathogen)
        }}
        disabled={chartForReview}
        onBlur={() => handlePathogenBlur(site, pathogen)}
        placeholder="Please make a selection"
        required={true}
        {...props.pathogen}
        {...props}
      />

      <Form.Label>
        Besides Gram negatives, were other pathogens identified from the same culture? (check all that apply):
      </Form.Label>
      <div key={'option.fieldName'}>
        {/* <Form validated={props.chartIsIncompleteModalData.length !== 0 ? true: false}> */}
          <Form.Check
            id={`${pathogenRadioIdName}-no_other_pathogens_in_same_culture`}
            type="radio"
            name={`${pathogenRadioIdName}-no_other_pathogens_in_same_culture`}
            label={'No'}
            checked={props.pathogen.no_other_pathogens_in_same_culture === true}
            value={'No'}
            onChange={(e, site, pathogen, fieldName) => checkboxPatchPathogen(!props.pathogen.no_other_pathogens_in_same_culture, props.site, props.pathogen, 'no_other_pathogens_in_same_culture')}
            required={props.pathogen.no_other_pathogens_in_same_culture !== true && props.pathogen.no_other_pathogens_in_same_culture !== false}
            disabled={chartForReview}
          />
          <Form.Check
            id={`${pathogenRadioIdName}-other_pathogens_in_same_culture`}
            type="radio"
            name={`${pathogenRadioIdName}-other_pathogens_in_same_culture`}
            label={'Yes'}
            checked={props.pathogen.no_other_pathogens_in_same_culture === false}
            value={'Yes'}
            onChange={(e, site, pathogen, fieldName) => checkboxPatchPathogen(!props.pathogen.no_other_pathogens_in_same_culture, props.site, props.pathogen, 'no_other_pathogens_in_same_culture')}
            required={props.pathogen.no_other_pathogens_in_same_culture !== true && props.pathogen.no_other_pathogens_in_same_culture !== false}
            disabled={chartForReview}
          />
        {/* </Form> */}

        { !props.pathogen.no_other_pathogens_in_same_culture
          ?
          pathogenInSameCultureQuestion()
          :
          null
        }
      </div>

      <br />

      <Row style={{ paddingBottom: "0" }}>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Form.Label>
            Were any susceptibility tests against the indicated Gram-negative pathogen reported?
          </Form.Label>
        </Col>
      </Row>

      <Row style={{ paddingTop: "0", marginBottom: "1rem" }}>
        <Col xs={12} sm={12} md={6} lg={6}>
          <Form.Check
            id={`${pathogenRadioIdName}-susceptibilityTestNotDone`}
            type="radio"
            name={`${pathogenRadioIdName}-susceptibilityTestNotDone`}
            label={'No'}
            checked={props.pathogen.susceptibility_test_done === false}
            value={'No'}
            onChange={handleSusceptibilityTestDone}
            required={props.pathogen.susceptibility_test_done !== false && props.pathogen.susceptibility_test_done !== true}
            disabled={chartForReview}
          />

          <Form.Check
            id={`${pathogenRadioIdName}-susceptibilityTestDone`}
            type="radio"
            name={`${pathogenRadioIdName}-susceptibilityTestDone`}
            label={'Yes'}
            checked={props.pathogen.susceptibility_test_done === true}
            value={'Yes'}
            onChange={handleSusceptibilityTestDone}
            required={props.pathogen.susceptibility_test_done !== false && props.pathogen.susceptibility_test_done !== true}
            disabled={chartForReview}
          />
        </Col>
      </Row>

      {
        props.pathogen.susceptibility_test_done
        ?
          <div className="indented-row">
            <SusceptibilityTests
              pathogen={pathogen}
              site={site}
              addNewSusceptibilityTest={addNewSusceptibilityTest}
              handleSusceptibilityTestBlur={handleSusceptibilityTestBlur}
              chartForReview={chartForReview}
              checkboxPatchPathogen={checkboxPatchPathogen}
              patchPathogen={patchPathogen}
              handlePathogenBlur={handlePathogenBlur}
              {...props}
            />
          </div>
        :
        null
      }

      <SelectWithOptionalTextField
        label='Did patient have the same pathogen prior to the current hospitalization?'
        options={samePathogenPriorToCurrentHospitalizationOptions}
        selectFieldName='patient_had_same_pathogen_prior_to_hospitalization'
        selected={pathogen.patient_had_same_pathogen_prior_to_hospitalization}
        handleSelect={handleSelect}
        handleChange={handlePatientHadSamePathogenSelect}
        onBlur={() => handlePathogenBlur(site, pathogen)}
        disabled={chartForReview}
        placeholder="Please make a selection"
        required={true}
        {...props}
      />

      {
        props.pathogen.patient_had_same_pathogen_prior_to_hospitalization.includes('Yes')
        ?
        <div className="indented-row">
          <FormInput
            label={'Date of onset of the first clinical sign and symptom:'}
            name={'initial_positive_culture_date'}
            value={pathogen.initial_positive_culture_date}
            type={'date'}
            onChange={(e, site, pathogen, name) => patchPathogen(e, props.site, props.pathogen, 'initial_positive_culture_date')}
            disabled={chartForReview}
            required={true}
            errorText={getHelperText('initial_positive_culture_date')}
          />
          {sourceOfCultureSampleOptions.map(option => {
            const optionIsSelected = props.pathogen[option.fieldName] === true ? true : false
            return (
              <div className="indented-row" key={option.fieldName}>
                <Form.Check
                  id={option.fieldName}
                  name={option.fieldName}
                  label={option.displayName}
                  value={optionIsSelected}
                  checked={optionIsSelected}
                  onChange={(optionIsSelected, site, pathogen, name) => checkboxPatchPathogen(!props.pathogen[option.fieldName], props.site, props.pathogen, option.fieldName)}
                  disabled={chartForReview || savingChartPhase ? true : false}
                  required={getRequired(sourceOfCultureSampleOptions)}
                />

                {optionIsSelected && option.textFields && option.textFields.length > 0 ?
                <Fragment>
                  {option.textFields.map(textField => {
                    return (
                      <Row className="indented-row" key={textField.fieldName}>
                        <Form.Label>
                          {textField.displayName}
                        </Form.Label>
                        <Form.Control
                          type={'text'}
                          name={'source_of_culture_sample_other_text'}
                          value={pathogen.source_of_culture_sample_other_text}
                          onChange={(e, site, pathogen) => checkboxPatchPathogen(e, props.site, props.pathogen)}
                          disabled={chartForReview}
                          required={true}
                        />
                      </Row>
                    )
                  })}
                </Fragment>
                :
                null}
            </div>
        )})}
      </div>
      :
      null
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    primary_infection_sites: state.infectionCourseFormReducer.primary_infection_sites,
    currentUser: state.loginReducer.currentUser,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updatePathogen: (primaryInfectionSites, primaryInfectionSite, pathogen, name, selection) => dispatch(updatePathogen(primaryInfectionSites, primaryInfectionSite, pathogen, name, selection)),
    deleteSusceptibilityTestFromServer: (susceptibilityTestToRemove, props) => dispatch(deleteSusceptibilityTestFromServer(susceptibilityTestToRemove, props)),
    updatePrimaryInfectionSite: (value, name) => dispatch(updatePrimaryInfectionSite(value, name)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PathogenSpecificQuestions)
